
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 18H0v-2h1V9.031C1 4.043 5.03 0 10 0s9 4.043 9 9.031V16h1v2zM3 16h14V9.031C17 5.148 13.866 2 10 2S3 5.148 3 9.031V16zm4.5 3h5a2.5 2.5 0 01-5 0z","fill":"#FAAD14"}})])
          )
        }
      }
    